import React from 'react';

interface TopbarProps {
  userName: string;
  onRefresh: () => void;
  lastUpdated?: Date;
}

export const Topbar: React.FC<TopbarProps> = ({ userName, onRefresh, lastUpdated }) => {
  const initials = userName.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase();

  return (
    <div style={{
      background: 'var(--chk-navy)', borderBottom: '1px solid var(--chk-border)',
      padding: '0 24px', height: 56, display: 'flex', alignItems: 'center',
      justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 100,
    }}>
      {/* Left — brand */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <svg width="36" height="36" viewBox="0 0 36 36">
          <defs>
            <clipPath id="ring">
              <path d="M18 0a18 18 0 1 1 0 36A18 18 0 0 1 18 0zm0 8a10 10 0 1 0 0 20A10 10 0 0 0 18 8z"/>
            </clipPath>
          </defs>
          <g clipPath="url(#ring)">
            <rect x="0"  y="0"  width="12" height="36" fill="#CC2936"/>
            <rect x="12" y="0"  width="12" height="36" fill="#1755B8"/>
            <rect x="24" y="0"  width="12" height="36" fill="#FFFFFF"/>
          </g>
        </svg>
        <div>
          <div style={{ fontSize: 17, fontWeight: 700, color: 'var(--chk-white)', letterSpacing: 0.5 }}>CHK Pipeline</div>
          <div style={{ fontSize: 11, color: 'var(--chk-muted)' }}>DCM · DTI · Gestão de Oportunidades</div>
        </div>
      </div>

      {/* Right — actions + user */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {lastUpdated && (
          <div style={{ fontSize: 11, color: '#3A3F55', display: 'flex', alignItems: 'center', gap: 4 }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#22C55E', display: 'inline-block', boxShadow: '0 0 6px #22C55E' }}/>
            Actualizado: {lastUpdated.toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
          </div>
        )}
        <button onClick={onRefresh} title="Actualizar" style={{
          width: 36, height: 36, border: '1px solid var(--chk-border)',
          background: 'var(--chk-card)', borderRadius: 8, cursor: 'pointer',
          color: 'var(--chk-muted)', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>↻</button>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 8,
          background: 'var(--chk-card)', border: '1px solid var(--chk-border)',
          padding: '5px 12px 5px 7px', borderRadius: 20,
        }}>
          <div style={{
            width: 28, height: 28, borderRadius: '50%',
            background: 'linear-gradient(135deg, #CC2936, #1755B8)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 11, fontWeight: 700, color: 'white',
          }}>{initials}</div>
          <span style={{ fontSize: 13, color: 'var(--chk-text)' }}>{userName}</span>
        </div>
      </div>
    </div>
  );
};
